module.exports = __webpack_public_path__ + "static/img/iphone.7111348b.png";